import React, { useEffect, useRef, useState } from "react"
import { Accordion } from "react-bootstrap"
import EmployeeInfo from "../../../../components/EmployeeInfo/EmployeeInfo"
import LoadingSpinner from "../../../../components/Loading/LoadingSpinner"
import EmployeeAccordion from "../../../../components/Selection/EmployeeAccordion"
import { getAllEmployeeInfo, createUser } from "../../../../firestore/firestore"
import { createAccountWithoutSignIn } from "../../../../auth/auth"
import PullToRefresh from "react-simple-pull-to-refresh"
import { sortArrayOfObjects } from "../../../../util/helper"
import AddUserModal from "../../../../components/Modals/AddUserModal"
import "./employees.css"

export default function Employees() {
  const [employees, setEmployees] = useState("")
  const [currentTarget, setCurrentTarget] = useState(null)
  const [showAddModal, setShowAddModal] = useState(false)
  const accordionRef = useRef()

  useEffect(() => {
    handleRefresh()
  }, [])

  useEffect(() => {
    if (!currentTarget) {
      return
    }
    accordionRef.current = currentTarget

    setTimeout(
      () =>
        accordionRef.current.scrollIntoView({
          behavior: "smooth",
          block: "start",
        }),
      200,
    )
  }, [currentTarget])

  async function handleRefresh() {
    const getEmployeeData = async () => {
      const employeeData = await getAllEmployeeInfo()
      const sortedEmployeeInfo = employeeData.sort((a, b) => sortArrayOfObjects(a.lastName, b.lastName))
      setEmployees(sortedEmployeeInfo)
      return sortedEmployeeInfo
    }
    getEmployeeData().catch((err) => console.log(err))
  }

  function handleAccordion(e) {
    const element = e.currentTarget
    setCurrentTarget((prevTarget) => (prevTarget = element))
  }

  async function handleAddEmployee(formData) {
    try {
      const user = await createAccountWithoutSignIn(formData.email, formData.password)
      const userData = {
        id: user.uid,
        firstName: formData.firstName,
        lastName: formData.lastName,
        fullName: formData.firstName + " " + formData.lastName,
        email: formData.email,
        role: "employee",
        imgUrl: "",
        mobile: formData.mobile,
        address: formData.address,
        city: formData.city,
        state: formData.state,
        zipcode: formData.zipcode,
        plants: [],
        messages: [],
        active: true,
      }
      await createUser(userData)
      alert(`Employee ${userData.fullName} created successfully.`)
      setShowAddModal(false)
      handleRefresh()
    } catch (err) {
      if (err.code === "auth/email-already-in-use") {
        alert("This email is already registered.")
      } else {
        alert("Error creating employee: " + err.message)
      }
      throw err
    }
  }

  if (employees) {
    return (
      <>
        <PullToRefresh onRefresh={handleRefresh} pullDownThreshold={90} resistance={3}>
          <Accordion className="custom-accordion">
            {employees.map((employee, i) => {
              return (
                <div key={i + employee.id} ref={accordionRef} onClick={handleAccordion}>
                  <EmployeeAccordion eventKey={i} employee={employee} refreshCallback={handleRefresh} id={i + employee.id}>
                    <EmployeeInfo employee={employee} i={i} />
                  </EmployeeAccordion>
                </div>
              )
            })}
          </Accordion>
          <div className="add-btn-container">
            <button className="btn-add" onClick={() => setShowAddModal(true)}>
              Add Employee
            </button>
          </div>
          <AddUserModal show={showAddModal} onClose={() => setShowAddModal(false)} onSubmit={handleAddEmployee} role="employee" />
        </PullToRefresh>
      </>
    )
  } else {
    return <LoadingSpinner />
  }
}
